import {
  Badge,
  Text,
  Tooltip,
  useComputedColorScheme,
  useMantineTheme,
} from '@mantine/core';
import { useSearchDiagnosis } from 'api/resource';
import { FC, ReactNode } from 'react';

interface ICD9BadgeProps {
  icd9: string;
}

interface ICD9TooltipProps {
  icd9: string;
  children: ReactNode;
}

export const ICD9Tooltip: FC<ICD9TooltipProps> = ({ icd9, children }) => {
  const { data: diagnoses, isLoading } = useSearchDiagnosis({
    searchValue: icd9,
    enabled: icd9?.length > 0,
  });
  const diagnosis = diagnoses?.find((candidate) => candidate.icd9 === icd9);

  return (
    <Tooltip
      label={
        diagnosis ? (
          <>
            <Text size="sm">{diagnosis.description}</Text>
            <Text size="xs" c="dimmed">
              ICD9: {diagnosis.icd9}
            </Text>
          </>
        ) : (
          <Text size="sm">
            {isLoading ? 'Loading diagnosis…' : `ICD9: ${icd9}`}
          </Text>
        )
      }
      position="top"
      withArrow
      multiline
    >
      <span style={{ display: 'inline-flex' }}>{children}</span>
    </Tooltip>
  );
};

export const ICD9Badge: FC<ICD9BadgeProps> = ({ icd9 }) => {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme('dark');

  return (
    <ICD9Tooltip icd9={icd9}>
      <Badge
        variant="filled"
        color={theme.colors[`tariff-icd9-${colorScheme}`]?.[0]}
        autoContrast
        size="md"
        radius="sm"
      >
        <Text inherit fs="italic" size="xs">
          {icd9}
        </Text>
      </Badge>
    </ICD9Tooltip>
  );
};
